module.exports = __webpack_public_path__ + "img/cztc.4eb4e00c.png";